import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Radium from 'radium';

class TdWeekDays extends Component {
  render() {
    const { mon, tue, wed, thu, fri, sat, sun, type } = this.props;
    return (
      <div className="text-right">
        <div style={[mon ? { color: '#DD534C' } : null, styles.data[type]]} className="col-xs-1">{mon}</div>
        <div style={[tue ? { color: '#DD534C' } : null, styles.data[type]]} className="col-xs-1">{tue}</div>
        <div style={[wed ? { color: '#DD534C' } : null, styles.data[type]]} className="col-xs-1">{wed}</div>
        <div style={[thu ? { color: '#DD534C' } : null, styles.data[type]]} className="col-xs-1">{thu}</div>
        <div style={[fri ? { color: '#DD534C' } : null, styles.data[type]]} className="col-xs-1">{fri}</div>
        <div style={[sat ? { color: '#DD534C' } : null, styles.data[type]]} className="col-xs-1">{sat}</div>
        <div style={[sun ? { color: '#DD534C' } : null, styles.data[type]]} className="col-xs-1">{sun}</div>
      </div>
    );
  }
}

var styles = {
  data: {
    ROOT: {
      lineHeight: '40px',
      fontWeight: '700'
    },
    SECOND: {
      lineHeight: '40px',
      fontWeight: '600'
    },
    THIRD: {
      lineHeight: '40px'
    }
  }
}

TdWeekDays.propTypes = {
  mon: PropTypes.number.isRequired,
  tue: PropTypes.number.isRequired,
  wed: PropTypes.number.isRequired,
  thu: PropTypes.number.isRequired,
  fri: PropTypes.number.isRequired,
  sat: PropTypes.number.isRequired,
  sun: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
};

export default Radium(TdWeekDays);


// WEBPACK FOOTER //
// ./src/App/Project/WeekOverview/ActivityTable/tdWeekDays.jsx